const initialState = {
    couriers: [],
    pageType: 'couriers', // couriers | selectForOrder
    consignmentCode: '',

    
    // inputUniqueCode: '',
    // inputUserName: '', 
    // inputMobile: '',
};

const couriers = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_PAGE_COURIERS':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default couriers;
